import { queryBrandSource } from './queryBrandSource';
import { resourceBrandSource } from './resourceBrandSource';
import { storeBrandSource } from './storeBrandSource';
import { tokenBrandSource } from './tokenBrandSource';
import type { BrandSource, BrandSourceName } from './types';
import { urlBrandSource } from './urlBrandSource';

export const BRAND_SOURCES: Record<BrandSourceName, BrandSource> = {
  query: queryBrandSource,
  url: urlBrandSource,
  resource: resourceBrandSource,
  store: storeBrandSource,
  token: tokenBrandSource,
};

export const brandSourcesByName = (names: BrandSourceName[]): BrandSource[] => names.map((name) => BRAND_SOURCES[name]);
